//////////////////////////////////////////////////////////////////////////////////////////////////////////////
///h : code:		plustic — massimo cardascia — www.plustic.de
///h : code language:	php 5.6
///h : code style:	whitesmiths style variant - 8 spaces tab - http://en.wikipedia.org/wiki/indent_style
//////////////////////////////////////////////////////////////////////////////////////////////////////////////


//////////////////////////////////////////////////////////////////////////////////////////////////////////////
///h : paths
//////////////////////////////////////////////////////////////////////////////////////////////////////////////


//////////////////////////////////////////////////////////////////////////////////////////////////////////////
///h : imports
//////////////////////////////////////////////////////////////////////////////////////////////////////////////


//////////////////////////////////////////////////////////////////////////////////////////////////////////////
///h : class definition
//////////////////////////////////////////////////////////////////////////////////////////////////////////////

///h : class
function dc7__string(){this.f_construct();}

	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : class properites
	//////////////////////////////////////////////////////////////////////////////////////////////////////

	///h : class vars
	dc7__string.__o_data = null;				///h : stores class data
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : class system init
	//////////////////////////////////////////////////////////////////////////////////////////////////////

	///h : init system
	/**
	 * init system
	 * initialising the system. all default mehtods to init data and content are
	 * called when the class is included.
	 * 
	 * @access public
	 * @param
	 * @return vault
	 */
	dc7__string.f_initSystem = function()
		{
		dc7__string.f_init();
		}


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : class methods - default
	//////////////////////////////////////////////////////////////////////////////////////////////////////

	///h : init
	/**
	 * init
	 * init class calling all default functions like initenvironment, initdata
	 * initcontent.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_init = function()
		{
		///: init config
		dc7__string.f_initData();

		///: init config
		dc7__string.f_initContent();
		}


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init data
	/**
	 * init data
	 * used to init all data later on used in the class context like
	 * configuration arrays etc.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_initData = function()
		{
		dc7__string.__o_data = {};
		dc7__string.__o_data['i_unique_id'] = 0;
		dc7__string.__o_data['o_data_presets'] = {};
		dc7__string.__o_data['o_data_presets']['query'] = {'a_remove_char':['?'], 's_attribute_divider':'&'};
		dc7__string.__o_data['o_escape'] = {'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#x27;', '`':'&#x60;'};
		}


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_initContent = function()
		{	
		}
		
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_replaceAt = function($s_data, $i_index__start, $i_index__end, $s_insert)
		{
		///h :
		$s_data = ($s_data.substr(0, $i_index__start) + '' + $s_insert + '' + $s_data.substr($i_index__end));
	
		///h :
		return($s_data);
		}


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_escape = function($s_data)
		{
		///h :
		var $s_loop = null;	///h :

		///h :
		for($s_loop in dc7__string.__o_data['o_escape'])
			{
			$s_data = $s_data.split($s_loop).join(dc7__string.__o_data['o_escape'][$s_loop]);
			}

		///h :
		return($s_data);
		}


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_unescape = function($s_data)
		{
		///h :
		var $s_loop = null;	///h :

		///h :
		for($s_loop in dc7__string.__o_data['o_escape'])
			{
			$s_data = $s_data.split(dc7__string.__o_data['o_escape'][$s_loop]).join($s_loop);
			}

		///h :
		return($s_data);
		}


	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_compare = function($s_data__a, $s_data__b, $o_config)
		{
		var $s_relation = null;		///h :

		///h :
		$o_config = (($o_config === undefined) ? {} : $o_config);
		$o_config['b_lowercase'] = dc7__var.f_initVar($o_config['b_lowercase'], true);

		///h :
		if($o_config['b_lowercase'] === true)
			{
			$s_data__a = $s_data__a.toLowerCase();
			$s_data__b = $s_data__b.toLowerCase();
			}

		///h :
		$s_relation = 'unequal';
		
		///h : compare - complete same
		if($s_data__a === $s_data__b)
			{
			$s_relation = 'equal';
			}
		///h : compare - wildcard
		else
			{
//			if((fnmatch($s_data__a, $s_data__b) === true) || (fnmatch($s_data__b, $s_data__a) === true))
//				{
//				$s_relation = 'equal';
//				}
			}

		///h :
		return($s_relation);
		}
	
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_getUniqueID = function($s_pefix)
		{
		$s_pefix = (($s_pefix == undefined) ? 'uid__' : $s_pefix);

		///h : return
		return($s_pefix + (dc7__string.__o_data['i_unique_id']++).toString(32) + String(new Date().getTime()).substr(6));
		}
		
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_encodeSpecialChars = function($s_data)
		{
		///h : 
		$s_data = $s_data.split(' ').join('***space***');
		$s_data = $s_data.split(';').join('***semicolon***');
		$s_data = $s_data.split(':').join('***colon***');

		///h : return
		return($s_data);
		}
		
//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_decodeSpecialChars = function($s_data)
		{
		///h : 
		$s_data = $s_data.split('***space***').join(' ');
		$s_data = $s_data.split('***semicolon***').join(';');
		$s_data = $s_data.split('***colon***').join(':');

		///h : return
		return($s_data);
		}
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_getObject = function($s_data)
		{
		///h :
		$o_data = $s_data;

		///h : 
		return($o_data);
		}
	
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_getDataObject = function($o_data, $o_config)
		{
		///h : 
		var $i_loop = -1;		///h :
		var $a_data_parts = null;	///h :
		var $i_data_parts = -1;		///h :
		var $s_data_part = null;	///h :
		
		///h : special case transmitted object		
		if(typeof($o_data) === 'object')
			{
			return($o_data);
			}

		///h : data
		$s_data = (($o_data === undefined) ? '' : $o_data);
		$o_config = (($o_config === undefined) ? {} : $o_config);
		$o_data = {};
	
		///h : check transmitted values
		$o_config['b_replace_assign'] = (($o_config['b_replace_assign'] === undefined) ? true : $o_config['b_replace_assign']);
		$o_config['b_replace_quotes'] = (($o_config['b_replace_quotes'] === undefined) ? true : $o_config['b_replace_quotes']);
		$o_config['s_attribute_assign'] = (($o_config['s_attribute_assign'] === undefined) ? '=' : $o_config['s_attribute_assign']);
		$o_config['s_attribute_divider'] = (($o_config['s_attribute_divider'] === undefined) ? ' ' : $o_config['s_attribute_divider']);
		$o_config['b_remove_brackets'] = (($o_config['b_remove_brackets'] === undefined) ? true : $o_config['b_remove_brackets']);
		$o_config['b_replace_specialchars'] = (($o_config['b_replace_specialchars'] === undefined) ? true : $o_config['b_replace_specialchars']);
		$o_config['b_replace_semicolon'] = (($o_config['b_replace_semicolon'] === undefined) ? true : $o_config['b_replace_semicolon']);
		$o_config['a_remove_char'] = (($o_config['a_remove_char'] === undefined) ? null : $o_config['a_remove_char']);
		$o_config['s_preset_id'] = (($o_config['s_preset_id'] === undefined) ? null : $o_config['s_preset_id']);
		
		///h : presets
		if($o_config['s_preset_id'] !== null) 
			{
			dc7__var.f_extendVar($o_config, dc7__string.__o_data['o_data_presets'][$o_config['s_preset_id']]);
			}

		///h : json case
		if($s_data.indexOf('{') === 0)
			{
			$o_data = jQuery.parseJSON($s_data);
			}
		else
			{
			///h :
			if($o_config['a_remove_char'] !== null)
				{
				$s_data = dc7__string.f_replace($o_config['a_remove_char'], '', $s_data);
				}

			///h : replace quotes
			if($o_config['b_replace_quotes'] === true)
				{
				$s_data = $s_data.split('"').join('\'');
				$s_data = $s_data.split('“').join('\'');
				$s_data = $s_data.split('"').join('\'');
				}
			

			///h : replace quotes
			if($o_config['b_replace_semicolon'] === true)
				{
				$s_data = $s_data.split(';').join(' ');
				}

			///h : remove brackets
			if($o_config['b_remove_brackets'] === true)
				{
				$s_data = $s_data.split('[').join('');
				$s_data = $s_data.split(']').join('');
				}

			///h : replace special chars
			if(($o_config['b_replace_specialchars'] === true) && ($s_data.indexOf('\'') > 0))
				{
				///h : parse
				$a_data_specialchars = $s_data.split('=\'');
				$i_data_specialchars = $a_data_specialchars.length;

				for($i_loop = 0; $i_loop < $i_data_specialchars; $i_loop++)
					{
					if($i_loop > 0)
						{
						///h :
						$s_data_specialchars = $a_data_specialchars[$i_loop];
						$s_data_specialchars = $s_data_specialchars.substr(0, $s_data_specialchars.indexOf('\''));
						$s_data_specialchars_encode = dc7__string.f_encodeSpecialChars($s_data_specialchars);

						///h :
						//$a_data_specialchars[$i_loop] = $s_data_specialchars;
						$s_data = $s_data.split($s_data_specialchars).join($s_data_specialchars_encode);
						}
					}
				}
				
			///h : replace assign
			if($o_config['b_replace_assign'] === true)
				{
				$s_data = $s_data.split(':').join('=');
				}

			$a_data_parts = $s_data.split($o_config['s_attribute_divider']);
			$i_data_parts = $a_data_parts.length;

			///h : parse
			for($i_loop = 0; $i_loop < $i_data_parts; $i_loop++)
				{
				$s_data_part = $a_data_parts[$i_loop];

				///h : 
				$i_divider_index = $s_data_part.indexOf($o_config['s_attribute_assign']);
				$s_var_name = (($i_divider_index < 1) ? $i_loop : $s_data_part.substr(0, $i_divider_index));
				$s_var_value = (($i_divider_index < 1) ? $s_data_part : $s_data_part.substr($i_divider_index + 1));

				if($o_config['b_replace_specialchars'] === true)
					{
					$s_var_value = dc7__string.f_decodeSpecialChars($s_var_value);
					$s_var_value = $s_var_value.split('\'').join('');
					}

				///h : transform to object
				$o_var_value = dc7__string.f_getObject($s_var_value);

				///h : update object
				$o_data[$s_var_name] = $o_var_value;
				}
			}
		
		///h : return
		return($o_data);
		}
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_replace = function($o_search, $s_replace, $s_data)
		{
		///h :
		var $i_loop = -1;		///h : stores loop index
		var $i_data = -1;		///h : stores loop elements
		var $s_search = null;		///h :
		
		///h : simple string replace
		if(typeof($o_search) === 'string')
			{
			$s_data = $s_data.split($o_search).join($s_replace);
			}
		///h : multiple array values to replace
		else
			{
			///h :
			$i_data = $o_search.length;
			for($i_loop = 0; $i_loop < $i_data; $i_loop++)
				{
				$s_search = $o_search[$i_loop];
				$s_data = $s_data.split($s_search).join($s_replace);
				}
			}

		///h : 
		return($s_data);
		}
		

	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_trim = function($s_data, $s_charlist)
		{
		///h : properties
		var $jqo_elements = null;	///h : stores jquery objects
		var $jqo_element = null;	///h : stores jquery object
		var $i_loop = -1;		///h : stores loop index
		var $i_elements = -1;		///h : stores loop elements
		var $s_whitespace = null;	///h : stores loop elements

		///h : init data
		$s_data += '';
		if($s_charlist === undefined)
			{
			$s_whitespace = ' \n\r\t\f\x0b\xa0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000';
			}
		else
			{
			$s_charlist += '';
			$s_whitespace = $s_charlist.replace(/([\[\]\(\)\.\?\/\*\{\}\+\$\^\:])/g, '$1');
			}

		///h :
		$i_elements = $s_data.length;
		for($i_loop = 0; $i_loop < $i_elements; $i_loop++)
			{
			if($s_whitespace.indexOf($s_data.charAt($i_loop)) === -1)
				{
				$s_data = $s_data.substring($i_loop);
				break;
				}
			}

		///h :
		$i_elements = $s_data.length;
		for($i_loop = $i_elements - 1; $i_loop >= 0; $i_loop--)
			{
			if($s_whitespace.indexOf($s_data.charAt($i_loop)) === -1)
				{
				$s_data = $s_data.substring(0, $i_loop + 1);
				break;
				}
			}

		///h :
		$s_data = (($s_whitespace.indexOf($s_data.charAt(0)) === -1) ? $s_data : null);

		///h : return
		return($s_data);
		}

		
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_updateURI = function()
		{
		///h : check change
		$s_uri_complete = location.href;
		if(dc7__string.__o_data['s_uri_complete'] === $s_uri_complete)
			{
			return;
			}
		dc7__string.__o_data['s_uri_complete'] = $s_uri_complete;
		
		
		}
		
		
	//////////////////////////////////////////////////////////////////////////////////////////////////////
	///h : init content
	/**
	 * init content
	 * initializing content and potential html rendering all requests
	 * to other uris.
	 *
	 * @access public
	 * @param
	 * @return vault
	 *
	 */
	dc7__string.f_getURI = function($s_part, $s_uri, $b_trim_slashes)
		{
		///h : 
		$s_uri = (($s_uri === undefined) ? location.href : $s_uri);
			
		///h : 
		$o_uri = dc7__string.f_parseURI($s_uri);
		$s_uri = $o_uri[$s_part];

		///h : return
		return($s_uri);
		}


//////////////////////////////////////////////////////////////////////////////////////////////////////////////
///h : direct call
//////////////////////////////////////////////////////////////////////////////////////////////////////////////

///h : init system
jQuery(document).bind('ready', {}, function(){dc7__string.f_initSystem();});


//////////////////////////////////////////////////////////////////////////////////////////////////////////////
///h : description
//////////////////////////////////////////////////////////////////////////////////////////////////////////////

/*
 
///h : objects in data attributes - used in www.beautyandphoto.com for behavior__relation
///h : data-dc7__behavior__relation=\'{"o_properties":{"eins":"zwei"}}\'
dc7__string.f_getDataObject($o_data, {'b_remove_brackets':false});

 */